import "./Slider.css";

import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";
import InputRange, { Range } from "react-input-range";

interface Props {
  formatLabel?: (value: number, type: string) => string;
  maxValue: number;
  minValue: number;
  onChange: (value: Range | number) => void;
  value: Range | number;
  step?: number;
  disabled?: boolean;
}

class Slider extends React.Component<Props & StyledComponentProps> {
  public render() {
    // const { classes } = this.props;

    return (
      <div style={{ padding: "1rem", maxWidth: "30rem" }}>
        <InputRange
          disabled={this.props.disabled}
          formatLabel={this.props.formatLabel}
          onChange={this.props.onChange}
          minValue={this.props.minValue}
          maxValue={this.props.maxValue}
          value={this.props.value}
          step={this.props.step}
          allowSameValues={true}
        />
      </div>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  activeTrack: {
    background: "#3f51b5",
  },
  disabledInputRange: {
    background: "#cccccc",
    border: "1px solid #cccccc",
    boxShadow: "none",
    transform: "none",
  },
  inputRange: {
    height: "1rem",
    position: "relative",
    width: "100%",
  },
  labelContainer: {
    left: "-50%",
    position: "relative",
  },
  maxLabel: {
    bottom: "-1.4rem",
    color: "#aaaaaa",
    fontFamily: '"Helvetica Neue", san-serif',
    fontSize: "0.8rem",
    left: "50%",
    position: "absolute",
    right: 0,
    transform: "translateZ(0)",
    whiteSpace: "nowrap",
  },
  minLabel: {
    bottom: "-1.4rem",
    color: "#aaaaaa",
    fontFamily: '"Helvetica Neue", san-serif',
    fontSize: "0.8rem",
    left: 0,
    position: "absolute",
    transform: "translateZ(0)",
    whiteSpace: "nowrap",
  },
  slider: {
    background: "#3f51b5",
    border: "1px solid #3f51b5",
    borderRadius: "100%",
    cursor: "pointer",
    display: "block",
    height: "1rem",
    marginLeft: "-0.5rem",
    marginRight: "-0.65rem",
    outline: "none",
    position: "absolute",
    top: "50%",
    transition: "transform 0.3s ease-out, box-shadow 0.3s ease-out",
    with: "1rem",
  },
  sliderContainer: {
    transition: "left 0.3s ease-out",
  },
  track: {
    background: "#eeeeee",
    borderRadius: "0.3rem",
    cursor: "pointer",
    display: "block",
    height: "0.3rem",
    left: "0",
    marginTop: "-0.15rem",
    position: "absolute",
    right: "0",
    top: "50%",
    transition: "left 0.3s ease-out, width 0.3s ease-out",
  },
  valueLabel: {
    color: "#aaaaaa",
    fontFamily: '"Helvetica Neue", san-serif',
    position: "absolute",
    top: "-1.8rem",
    transform: "translateZ(0)",
    whiteSpace: "nowrap",
  },
});

export default withStyles(styles)(Slider);



// WEBPACK FOOTER //
// ./src/components/Slider.tsx